import React from 'react'
import './style.css';

export const ChangelogMarkdown = () => {
    return (
        <div className='markdown-body' style={{
            boxSizing: 'border-box',
            minWidth: 200,
            maxWidth: 980,
            margin: '0 auto',
            padding: 15
          }}>
            <h1>ROAMES App Hub Release Notes</h1>
<p>All notable changes to this project will be documented in this file.</p>
<h2>
<a className="anchor" href="#1.0.1" id="1.0.1">
<svg aria-hidden="true" className="octicon octicon-link" height="16" version="1.1" viewbox="0 0 16 16" width="16">
  <path d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path>
</svg>
</a>[1.0.1] - 2021-08-31</h2>
<h3>
<a className="anchor" href="#1.0.1-changed" id="1.0.1-changed">
<svg aria-hidden="true" className="octicon octicon-link" height="16" version="1.1" viewbox="0 0 16 16" width="16">
  <path d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path>
</svg>
</a>Changed</h3>
<ul>
<li>Updated ROAMES World URL.</li>
<li>Updated news items.</li>
</ul>
<h2>
<a className="anchor" href="#1.0.0" id="1.0.0">
<svg aria-hidden="true" className="octicon octicon-link" height="16" version="1.1" viewbox="0 0 16 16" width="16">
  <path d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path>
</svg>
</a>[1.0.0] - 2021-07-09</h2>
<h3>
<a className="anchor" href="#1.0.0-added" id="1.0.0-added">
<svg aria-hidden="true" className="octicon octicon-link" height="16" version="1.1" viewbox="0 0 16 16" width="16">
  <path d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path>
</svg>
</a>Added</h3>
<ul>
<li>Initial version of the app hub.</li>
</ul>

        </div>
    )
}
